import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'formly-field-file',
  template: `
    <input type="file" class="d-block"
           [formControl]="formControl"
           [formlyAttributes]="field"
           [multiple]="to.multiple ? to.multiple : false">
    <div *ngIf="to.percentDone !== undefined && to.percentDone > 0" class="row">
      <div class="col-12 mt-2">
        <progressbar [value]="to.percentDone" type="success"
                     [striped]="true">{{to.percentDone}}%</progressbar>
      </div>
    </div>
  `,
})
// tslint:disable-next-line:component-class-suffix
export class FormlyFieldFile extends FieldType {}
